
import { useEffect,useState,useContext } from "react";
import "./Reports.css"
// import useAuth from "../../Hooks/UseAuth";
import { DateRangePicker } from 'react-date-range';
import {addDays} from "date-fns";
import format from "date-fns/format";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BeatLoader from "react-spinners/BeatLoader";

import { faHome,faClipboard,faChartLine,faChevronDown,faUserShield, faGear, faTimes } from '@fortawesome/free-solid-svg-icons'

import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import useAxiosPrivate from "../../Hooks/useAxiosPrivate";
import useAuth from "../../Hooks/UseAuth";
import AuthContext from "../../Context/AuthProvider";


function Reports(){  
    const[tData, setTData] = useState([]);
    const[sData, setSData] = useState([]);
    const options = ["Allowance","Deduction","Deduction Repayment"];
    // const[tidType, settidType] = useState([]);
    // const[rid, setrid] = useState("");
    // const[accno, setaccno] = useState([]);
    // const[amount, setamounta] = useState([]);
    // const[notes, setnotes] = useState([]);
    const[UID, setUID] = useState([]);
    const[ridSec, setridSec] = useState([]);
    const [tidType,setType] = useState(); 
    const [rid,setRID] = useState(); 
    const [amount,setAmount] =useState(); 
    const [one,setOne] =useState(true); 
    const [two,setTwo] =useState(false); 
    const [three,setThree] =useState(false); 
    const [notes,setNotes] = useState(); 
    const [accno,setAccNo] = useState(); 
    const [name,setName] = useState(""); 
    const [editStatus,seteditStatus] = useState(); 
    const [dropState,setDropState] =useState(false); 
 


    const [date,setDate] =useState(""); 
    const [selected,setSelected] = useState("Select Transaction Type"); 
    const [successMsg,setSuccessMsg] = useState(false); 
    const [errorMsg,setErrorMsg] = useState(false); 
    const [Msg,setMsg] = useState(""); 
    const [errorMsgLit,setErrorMsgLit] = useState(""); 
    const [Loading, setLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [editDisplay, setEditDisplay] = useState(false);
    const { setAuth,auth } = useContext(AuthContext);
    // const [UID, setUID] = useState('');
    // const auth = useAuth();
    const[visible, setVisible] = useState(false);
    const[drange, setDrange] = useState([{
        startDate: new Date(),
        endDate: addDays(new Date(),7),
        key: 'selection',
        
    }]);

    // tidType,
    // // rid,
    // // email : auth.user,
    // // Branch,
    // // accno,
    // // amount,
    // // 			tidType,
    //     rid,
    //     accno,
    //     amount,
    //     notes,
    //     UID,
    // const {auth} = useAuth(); 
    // const [authname, setAuthname] = useState(auth.dat.name);
    const [zra,setZra] = useState();
    const [napsa,setNapsa] = useState(75);
    const [dedtSum,setDeductSum] = useState();
    const [earnSum,setEarnSum] = useState(0);
    const[basepay, setBasepay] = useState();

    //   dedtSum = zra+napsa;

//     async function populateData(){  

//         // const response = await fetch("https://superagentback.onrender.com/api/Alltransactions",{
//         const response = await fetch("https://nerdayb.onrender.com/api/PayReports",{
//             headers : { 
//             //   'x-access-token' : auth.user,
//               }
//           // body: JSON.stringify({
//           //     quote,
              
//           // })
//         })
        
//         const data = await response.json();
//         // console.log("All Data here",data.propdata)
//         if(data){

//        if(data.status == "ok") {
//           setTData(data.propdata)
//         }else{
      
//            console.log("testign first")
//         } 

//      }
        
//         return data;
        
//   } 



  const setRangeViz = () =>{
    setVisible(!visible)

}
const handleSelect = () =>{ 
         
    setDropState(!dropState); 
}



useEffect(()=>{
    console.log("ranges",drange)
},[drange])


//////////////////////
const [searchData, setSearchData] = useState(""); 
const [fildata, setFildata] = useState([]); 
const [userData, setUserData] = useState([]); 
const[rData, setRData] = useState([]);
const[tax, setTax] = useState(0);
var dedSum = 0; 
var allwSum = 0; 
var zraTax = 0; 



  const [value, setValue] = useState(
      { 
  
          Locat : '',
          Fromto : "",
          Message : ""
  
      }
  )
  const [inpV, setInpV] = useState("");

  const handleFilter = (event) =>{ 
      console.log(event.target.value);
      const searchWord = event.target.value;
      const newFilter = searchData.filter((value)=>{
          console.log("searchWord",searchWord)
           return value.name.toLowerCase().includes(searchWord.toLowerCase());
            
      })

      setFildata(newFilter);
 }

//   async function populateDataSec(){  

//       // const response = await fetch("https://superagentback.onrender.com/api/Alltransactions",{
//       const response = await fetch("https://nerdayb.onrender.com/api/Alltransactions",{
//           headers : { 
//           //   'x-access-token' : auth.user,
//           }
//       // body: JSON.stringify({
//       //     quote,
          
//       // })
//       })
      
//       const data = await response.json();
//       console.log("All Data here",data.propdata)

//       if(data){

//         if(data.status == "ok") {

//             // const[sData, setSData] 
//             // setTData(data.propdata)
//             setSearchData(data.propdata)
//             console.log("Data here",data)
//             }else{
//             //    alert(data.error,"Here!")
//             console.log("testign first")
//             } 

//         }
        
// //   console.log(data,"aync test");
  
//   return data;
  
// }        

async function handleSubmit(event) {
    event.preventDefault();
    setLoading(true);


    /////
    const req = await axiosPrivate.post("/txns/EditTXNSyyy",
    //  const response = await axiosPrivate.post("http://localhost:2000/users",
        JSON.stringify({
            tidType,
            rid,
            // email : auth.user,
            // Branch,
            // accno,
            // amount,
            // 			tidType,
                // tid,
                ridSec,
                accno,
                amount,
                notes,
                UID :   auth?.foundUser?._id,
                
           
         }),
        // JSON.stringify({ user, pwd }),
        {
            headers: { 'Content-Type': 'application/json',
           
         },
            
            withCredentials: true,
            crossDomain: true,
            
        }
    );

    ////

    const data = await req;
    if(data.data.status== "Ok"){ 
        setLoading(false);
        setAmount("");
        setAccNo("")
        setRID("")
        setSelected("Select Transaction Type");
        setSuccessMsg(true);
        // console.log(auth)
        
    
    }else{
        setLoading(false);
        setErrorMsg(true);
        setMsg(data.msg)
        setErrorMsgLit(data.error);
    }
    // console.log("Data here", data)
    
}

    




      

            const handleSelected = (item) =>{
                
            
                setUserData(item);
                console.log("userdada",userData)


            }

            const [users, setUsers] = useState();
            const axiosPrivate = useAxiosPrivate();

            useEffect(() => {
                let isMounted = true;
                const controller = new AbortController();
          
                const getUsers = async () => {
                    try {
                        const response = await axiosPrivate.get('/users', {
                            signal: controller.signal,
                            params: {
                
                                Org: auth.foundUser.Org,
                                // org: 'value2',
                                // mgtLvl: 'value2',
                              }
                        });
                        console.log(response.data);
                        console.log("Heresummary fgfda",response);
                        isMounted && setUsers(response.data);
                        // setTData(response?.data)
                        setSearchData(response?.data)
                    } catch (err) {
                        console.error(err);
                      //   navigate('/login', { state: { from: location }, replace: true });
                    }
                }
                console.log("contect",auth)
                getUsers();
          
                return () => {
                    isMounted = false;
                    controller.abort();
                }
            }, [])


            useEffect(() => {
                let isMounted = true;
                const controller = new AbortController();
                // http://localhost:2000/txns/AdmnTXNS
            
                const getUsers = async () => {
                    try {
                        const response = await axiosPrivate.get('/txns', {
                            signal: controller.signal,
                            params: {
                
                                Org: auth.foundUser.Org,
                                // org: 'value2',
                                // mgtLvl: 'value2',
                              }
                        });
                        // console.log(response.data);
                        if(response.data){
                            console.log("Here 3333444");
                        setTData(response.data.propdata);
                        console.log("response",response)
                        }
                        
                      //   isMounted && setUsers(response.data);
                    } catch (err) {
                        console.error(err);
                      //   navigate('/login', { state: { from: location }, replace: true });
                    }
                }
                console.log("contect",auth)
                getUsers();
                console.log("teadaa",tData)
            
                return () => {
                    isMounted = false;
                    controller.abort();
                }
            }, [])




            // const zraHandler = (BasePay) =>{

            //     var remainderf = BasePay;

               
            //     console.log("in zra", BasePay)
            //     console.log("tax",tax);
            //     if(BasePay<4800){
            //         zraTax=0;
            //         console.log("tax",zraTax);
           
            //     else if((BasePay - 4800>0) && ((BasePay - 4800<1500)) ){

            //         var remainder = BasePay % 4800;
            //         zraTax=remainder*0.2;
            //         // setTax(remainder*0.2)
            //         console.log("remainder",remainder);
            //         console.log("tax",zraTax);

            //     } else if(BasePay - 4800>1500){
            //         var remainder = BasePay % 4800;
            //         zraTax=remainder*0.375;
            //         // setTax(remainder*0.375)
            //         console.log("remainder",remainder);
            //         console.log("tax",zraTax);

            //     }

           
            // }
            const zraHandler = (BasePay) =>{

                var remainderf = BasePay;
                zraTax = 0;
                var count = 1;
                
                while(remainderf>0){

            
    
                    if((BasePay<4800) && (count==1)){
                        zraTax=0;
                        console.log("tax",zraTax);
                        remainderf = 0;

                    }else if(count ==1){

                        if(((6800-remainderf)<1)){

                            zraTax = zraTax + (2000*0.2)
                            remainderf = remainderf - 6800;
                            count++;
                           
                        }else{      
                            // remainderf = 6800 - remainderf; 
                            remainderf = remainderf - 4800; 
                            zraTax = zraTax + remainderf*0.2;
                            count++;
             

                        }
                      
                    }else if(count==2){
                        
                        if(((2100-remainderf)<1)){

                            zraTax = zraTax + (2100*0.3)
                            remainderf = remainderf - 2100;
                            count++;
                         

                        }else{      
                            // remainderf = 2100 - remainderf; 
                            zraTax = zraTax + remainderf*0.3;
                            count++;
                         

                        }

                    }else if(count==3){  

                        zraTax = zraTax + (remainderf*0.375);
                        remainderf = 0;
                        count++;

                    }
                    else{

                        count++
                        console.log("count",count);
                        remainderf=0;

                    }

                }
               
               
            

           
            }

    return( 

        <>  
            <div className="CompensationCard">

                        <div className="cardHeading"><h2>Pay Report</h2></div>
                          <div className={editDisplay? "EditCover" : "NoEditCover"}>
                            
                            <div className="EditCoverHeading">

                                <h2>Edit Transaction</h2>
                               
                                <FontAwesomeIcon 
                                icon={faTimes} className="FontAwesomeIcon"
                                onClick={()=>{
                                    setEditDisplay(false)
                                    setOne(true)
                                    setTwo(false)
                                    setThree(false)
                                
                                }}
                                />

                            </div>
                             {one && <>  


                              <div className="InCardCover">

                              <div className="PopcardITem">
                                
                                  <div className="Heading">
                                      <b> <p>Date</p></b>
                                  </div>
                                  <div className="Item">
                                       <p>{date}</p>
                                  </div>

                                </div>
                                <div className="PopcardITem">
                                  <div className="Heading">
                                       <b><p>Type</p></b>
                                  </div>
                                  <div className="Item">
                                       <p>{tidType}</p>
                                  </div>

                                </div>
                                <div className="PopcardITem">
                                  <div className="Heading">
                                     <b> <p>Notes</p></b>
                                  </div>
                                  <div className="Item">
                                       <p>{notes}</p>
                                  </div>

                                </div>

                              </div>
                              {/* End of in card */}
                                     <div className="InCardCover">

                                        
                                            <div className="PopcardITem">
                                            <div className="Heading">
                                               <b> <p>Amount</p></b>
                                            </div>
                                            <div className="Item">
                                                <p>{amount}</p>
                                            </div>

                                            </div>
                                            <div className="PopcardITem">
                                            <div className="Heading">
                                               <b><p>Employee</p></b>
                                            </div>
                                            <div className="Item">
                                                <p>{userData.name}</p>
                                            </div>

                                            </div>
                                            <div className="PopcardITem">
                                            <div className="Heading">
                                              <b><p>Edit Status</p></b>
                                            </div>
                                            <div className="Item">
                                                <p>{editStatus}</p>
                                            </div>

                                            </div>

                                        </div>
                              {/* End of in card */}
                              <div className="EditBtnCover">
                                  <div className="firstBtn"
                                        onClick={()=>{
                                            setTwo(true)
                                            setOne(false)
                                            setThree(false)
                                        }}
                                  >   
                                         <button>Edit</button>

                                  </div>
                                     <div className="secBtn"

                                             onClick={()=>{
                                                setTwo(false)
                                                setOne(false)
                                                setThree(true)
                                        }}
                                     
                                     >
                                     <button>Delete</button>
                                  </div>
                                    
                                   

                              </div>

                                
                                </>}
                                {/* End of initial card */}
                                {
                                    two && <>

                                      <div className="innerCover">


                                      <form onSubmit={handleSubmit}>   
           {/* <form onSubmit={valFunc}>    */}
           
                                    
                                    <div className="textEntry">
                                    
                                        <div className='inputGroupa'>  

                        {/* TRANSACTION INPUT FIELDS*/}

                        <div className='dropContainer'>

                       

                    
                                <div className='categoryButton'  onClick={handleSelect} >

                                      <div> <p>{selected}</p> </div>  
                                      <div> <FontAwesomeIcon icon={faChevronDown} className="FontAwesomeIcon"/></div>

                                </div>
                                       
                                { dropState && <div className='dropDownList'>      
                                                                                         
                                                                       
                                                       { options.map((item,key)=>{
                                                       
                                                          return(
                                                                <div  name="Industry" 
                                                                                    // onChange={handleChange} 
                                                                                    value={selected} onClick={e => {
                                                                                    setSelected(item);
                                                                                    setType(item);
                                                                                    setDropState(false);
                                                                                    console.log("select",selected)
                                                                                  
                                                               
                                                                }}
                                                             
                                                             
                                                             
                                                             key={item} className='dropDownItem'>
                                                                   <p>{item}</p>
                                                              </div>
                                                          )})        

                                                        }

                                               </div>                                                                                                                        

                                      }
                               

                   

                        </div>

                       </div>
                   

                 </div>
                                      
                                    {/* Account No */}
                                    <div className="textEntry">
                                                
                                            <input 
                                            type="text"
                                            value={notes} 
                                            // minlength="10"
                                            // maxlength="10" 
                                            required
                                            onChange={(e)=>{setNotes(e.target.value)}}
                                            ></input>
                                              <span></span>
                                            <label>Note</label>

                                    </div>
                                    {/* Account No */}
                                    <div className="textEntry">
                                                
                                            <input 
                                            type="text"
                                            value={userData.name} 
                                            min="1"
                                            required
                                            disabled
                                            // minlength="10"
                                            // maxlength="10"
                                             
                                            
                                            onChange={(e)=>{setAccNo(e.target.value)}}
                                            ></input>
                                              <span></span>
                                            <label>User</label>

                                    </div>
                                    {/* Amount */}
                                    <div className="textEntry">
                                                
                                            <input 
                                            type="number"
                                            value={amount} 
                                            min="1"
                                            
                                            onChange={(e)=>{setAmount(e.target.value)}}
                                            ></input>
                                              <span></span>
                                            <label>Amount</label>

                                    </div>
                                    {successMsg && <div className="successMsgContainer">
                                            
                                                <p>{`Transaction successful!`}</p>
                                        </div>}
                                    {errorMsg && <div className="errorMsgContainer">
                                            
                                                <p>{`Transaction Failed! ${Msg}`}</p>
                                                
                                        </div>}

                                        {/* Loading Animation */}
                                        {Loading ?
                                        <div>
                                            <BeatLoader color="#36d7b7" />
                                        
                                        </div> :  
                                            <>  
                                                <div className="submitBtn">
                                                    <button type="submit">Submit</button>
                                                 </div>    
                                             
                                            </>   
                                        
                                        } 
                             
                               
                                </form>








                                        {/* End of Transaction cover */}
                                                       
                                      </div>
                                    </>
                                }
                                 {/* End of edit card */}
                                 {
                                    three && <>
                                          <h1>HI I am delete</h1>
                                    </>
                                }
                                  {/* End of delete card */}
                          
                          

                              

                          </div>
                        <div className="filterInputsContainer">

                        <div className="filterButton">
                            {/* Time filter */}

                            <input className="fromTo"
                               onClick={setRangeViz}
                               placeholder="All time"
                               value={`${format(drange[0].startDate,"dd/MM/yyyy")} to ${format(drange[0].endDate,"dd/MM/yyyy")}`}
                               type="text"
                               readOnly
                            >
                            </input>
                        
                            <div className={visible? "visible":"notVisible"}>
                                <h1></h1>
                                <DateRangePicker
                                        ranges={drange}
                                        onChange={item => setDrange([item.selection])}
                                        editableDateInputs={true}
                                        moveRangeOnFirstSelection={false}
                                        direction={'horizontal'}
                                        months={2}

                                    />

                            </div>
                             
                               
                        </div>

                             {/* Name search input field */}
                             <div className='searchBar'>  
                                
                                <div className='searchInputs'>
                                    <input type="text" name='Locat' onChange = {handleFilter} />
                                    <div className='ssearchIcon'> <i class="fa-solid fa-magnifying-glass"></i></div>

                                    { 
                                    fildata.length > 0 && 
                                    (

                                    <div className='dataResults'>
                                    {
                                    searchData && 
                                    
                                    fildata.map((index,key)=>{
                                        
                                        return (
                                        <div onClick={()=>handleSelected(index)} ><a key={key} className='datItem'>{index.name}</a></div>
                                        
                                        )
                                    
                                    })} 
                                
                                </div>


                                    )
                                }

                                </div>
                                </div>
                        </div>
                      
                        <div className="compensationCard">

                            <div className="payReport">
                                {/* <div className="prHeading">
                                        <div><p><b>Payslip</b></p></div>
                                        <div><p>Payment slip for the month of Janury 2021</p></div>
                                </div> */}
                                <div className="empDetailsContainer">
                                    <div className="empDetails">
                                        <div><p><b>Employee Name:</b></p></div>
                                        <div><p>{userData.name}</p></div>
                                    </div>
                                    <div className="empDetails">
                                        <div><p><b>Account_N0:</b></p></div>
                                        <div><p>{userData.AccountNo}</p></div>
                                    </div>
                                    <div className="empDetails">
                                        <div><p><b>PTO Days:</b></p></div>
                                        <div><p>{userData.PTO_Count}</p></div>
                                    </div>
                                    <div className="empDetails">
                                        <div><p><b>Balance B_Down:</b></p></div>
                                        
                                        <div><p>{userData.Advance_BF}</p></div>
                                    </div>
                                    <br/>
                                    {/* <div className="empDetails">
                                        <div><h3>Designation:</h3></div>
                                        <div><p>Chef</p></div>
                                    </div> */}


                                


                                </div>
                            

                            </div>
                        
                            {/* <div className="InpuTsubject"><p><b>Gender</b></p></div>
                            <div className="InpuTvalue">Male</div> */}
                            <h3>Earnings</h3>
                            <table className="contentTable"> 
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Earning</th>
                                        <th>Date</th>
                                        <th>Amount</th>
                                        <th>Note</th>
                                        <th></th>
                                        {/* <th>Recepient</th> */}
                                        
                                    </tr>
                                </thead>
                                <tbody>

                                        <tr>

                                        <td>{"1"}</td>
                                        <td>{"Basic Pay"} </td>
                                        <td>{""}</td>
                                        {/* <td>{new Date()}</td> */}
                                        
                                        
                                        <td>{`${userData.Base_Pay}`}</td>
                                        <td>{"Basic Pay"}</td>
                                        {/* <td>{item.transactionID}</td>
                                        <td>{item.TAccount}</td> */}
                                        
                                    </tr>
                                  
                                

                                      {tData && tData
                                      .filter((row,index)=>{



                                        const date = new Date(row.TDate);
                                        // Checks if the data is within the filter range
                                        if ((drange[0].endDate > date) &&(drange[0].startDate < date)
                                         &&(row.txnID == userData._id) && (row.transactionType == "Allowance")) {
                                        
                                            
                                          
                                            return row;
                                        }
                                        
                                      })
                                      .map((item,index)=>{
                                     
                                   
                                     allwSum = allwSum + item.transactionAmount;

                                      var isod =  new Date(item.TDate).toISOString();
                                    //   var dates = format(isod, 'yyyy-MM-dd') 
                                    //    var datee = new Date(item.TDate)
                                    //    console.log("Date here",isod.toString().substring(2, 10))
                                    return(  
                                    <tr>

                                        <td>{index+3}</td>
                                        <td>{item.transactionType} </td>
                                        <td>{isod.toString().substring(2, 10)}</td>
                                        {/* <td>{new Date()}</td> */}
                                        
                                        <td>{item.transactionAmount}</td>
                                        <td>{item.Notes}</td>
                                        <td onClick={()=>{
                                              setAmount(item?.transactionAmount)
                                              setType(item?.transactionType)
                                              seteditStatus(item?.EditStatus)
                                              setDate(item?.TDate)
                                              setNotes(item?.Notes)
                                              setRID(item?._id)
                                              console.log("clicked",item)
                                          
                                        }}><FontAwesomeIcon
                                             icon={faGear} className="FontAwesomeIcon"
                                             onClick={()=>{setEditDisplay(true)}}
                                        /></td>
                                        {/* <td>{item.TAccount}</td> */}
                                        
                                    </tr>
                                  )
                                })} 

                                       <tr>

                                        <td><b>{"Gross Earning:"}</b></td>
                                        <td>{""} </td>
                                        <td>{""}</td>
                                        {/* <td>{new Date()}</td> */}
                                        
                                        <td>{""}</td>
                                        <td><b>{`ZMK ${allwSum+userData.Base_Pay}`}</b></td>
                                        {/* <td>{item.transactionID}</td>
                                        <td>{item.TAccount}</td> */}
                                        
                                    </tr>
                                  
                                
                                </tbody>
                            </table>
                            {/* Deductions Table */}
                            <br/>
                            <h3>Deductions</h3>
                            <table className="contentTable"> 
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Deduction</th>
                                        <th>Date</th>
                                        <th>Amount</th>
                                        <th>Note</th>
                                        <th></th>
                                        {/* <th>TID</th>
                                        <th>Recepient</th> */}
                                        
                                    </tr>
                                </thead>
                                <tbody>
                                 {tData && zraHandler(userData.Base_Pay)}
                                    <tr>

                                        <td>{"1"}</td>
                                        <td>{"ZRA"} </td>
                                        <td>{""}</td>
                                        {/* <td>{new Date()}</td> */}
                                        
                                        <td>{zraTax}</td>
                                        <td>{}</td>
                                        {/* <td>{()=>{zraHandler(userData.Base_Pay)}}</td> */}
                                        {/* <td>{item.transactionID}</td>
                                        <td>{item.TAccount}</td> */}
                                        
                                    </tr>
                                    <tr>

                                        <td>{"2"}</td>
                                        <td>{"Napsa"} </td>
                                        <td>{""}</td>
                                        {/* <td>{new Date()}</td> */}
                                        
                                        <td>{`${0.05*userData.Base_Pay}`}</td>
                                        <td>{"Statutory Contribution"}</td>
                                        <td></td>
                                        {/* <td>{item.transactionID}</td>
                                        <td>{item.TAccount}</td> */}
                                        
                                    </tr>
                                    <tr>

                                        <td>{"3"}</td>
                                        <td>{"NHIMA"} </td>
                                        <td>{""}</td>
                                        {/* <td>{new Date()}</td> */}
                                        
                                        <td>{`${0.01*userData.Base_Pay}`}</td>
                                        <td>{"Statutory Contribution"}</td>
                                        <td></td>
                                        {/* <td>{item.transactionID}</td>
                                        <td>{item.TAccount}</td> */}
                                        
                                    </tr>
                                     
                                      
                                     
                                   
                                      {tData && tData
                                      .filter((row)=>{

                                        zraHandler(userData.Base_Pay);
             
                                      
                                        const date = new Date(row.TDate);
                                        // Checks if the data is within the filter range
                                        if ((drange[0].endDate > date) &&(drange[0].startDate < date) 
                                       // &&(row.TAccount == userData.AccountNo) && (row.transactionType == "Deduction Repayment")) {
                                        &&(row.txnID == userData._id) && (row.transactionType == "Deduction Repayment")) {
                                            // Deduction","Deduction Repayment"
                                           
                                            return row;
                                        }else{
                                            console.log("failed testss",row.transactionType,"account No",userData._id,"taccout",row.txnID )
                                        }
                                        
                                      })
                                      .map((item,index)=>{
                                        dedSum = dedSum+item.transactionAmount;
                                       
                                  
                                      var isod =  new Date(item.TDate).toISOString();
                                    //   var dates = format(isod, 'yyyy-MM-dd') 
                                    //    var datee = new Date(item.TDate)
                                    //    console.log("Date here",isod.toString().substring(2, 10))
                                    return(  
                                    <tr>

                                        <td>{index+4}</td>
                                        <td>{item.transactionType} </td>
                                        <td>{isod.toString().substring(2, 10)}</td>
                                        {/* <td>{new Date()}</td> */}
                                        
                                        <td>{item.transactionAmount}</td>
                                        <td>{item.Notes}</td>
                                        <td onClick={()=>{
                                            setAmount(item?.transactionAmount)
                                            setType(item?.transactionType)
                                            seteditStatus(item?.EditStatus)
                                            setDate(item?.TDate)
                                            setNotes(item?.Notes)
                                            setRID(item?._id)
                                            console.log("clicked",item)
                                            
                                        }}><FontAwesomeIcon
                                             icon={faGear} className="FontAwesomeIcon"
                                             onClick={()=>{setEditDisplay(true)}}
                                        /></td>
                                        {/* <td>{item.transactionID}</td>
                                        <td>{item.TAccount}</td> */}
                                        
                                    </tr>
                                  )
                                })}
                                  
                                   <tr>

                                        <td><b>{"Total Deduction:"}</b></td>
                                        <td>{""} </td>
                                        <td>{""}</td>
                                        {/* <td>{new Date()}</td> */}
                                        
                                        <td>{""}</td>
                                        <td><b>{`ZMK ${dedSum+(0.01*userData.Base_Pay)+((0.05*userData.Base_Pay)+zraTax)}`}</b></td>
                                        {/* <td>{item.transactionID}</td>
                                        <td>{item.TAccount}</td> */}
                                        
                                    </tr>
                                
                                </tbody>
                            </table>

                            <div className="netPay">
                                <div><b>Net Pay:</b></div>
                                <div><p>{`_ ZMK ${" "}  ${(allwSum+userData.Base_Pay)-((dedSum)+(0.01*userData.Base_Pay)+(zraTax)+(0.05*userData.Base_Pay))}`}</p></div>
                            </div>

                       
                            <br/>
                            <br/>
                            <br/>
                            <br/>
                            <br/>
                            <br/>
                            <h3>Unslipped Deductions</h3>
                            <table className="contentTable"> 
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Deduction</th>
                                        <th>Date</th>
                                        <th>Amount</th>
                                        <th>Note</th>
                                        <th></th>
                                        {/* <th>TID</th>
                                        <th>Recepient</th> */}
                                        
                                    </tr>
                                </thead>
                                <tbody>
                                 {tData && zraHandler(userData.Base_Pay)}
                                                            
                                      {tData && tData
                                      .filter((row)=>{

                                        zraHandler(userData.Base_Pay);
             
                                      
                                        const date = new Date(row.TDate);
                                        // Checks if the data is within the filter range
                                        if ((drange[0].endDate > date) &&(drange[0].startDate < date) 
                                       // &&(row.TAccount == userData.AccountNo) && (row.transactionType == "Deduction Repayment")) {
                                        &&(row.txnID == userData._id) && (row.transactionType == "Deduction")) {
                                            // Deduction","Deduction Repayment"
                                           
                                            return row;
                                        }else{
                                            console.log("failed testss",row.transactionType,"account No",userData._id,"taccout",row.txnID )
                                        }
                                        
                                      })
                                      .map((item,index)=>{
                                        dedSum = dedSum+item.transactionAmount;
                                       
                                  
                                      var isod =  new Date(item.TDate).toISOString();
                                    //   var dates = format(isod, 'yyyy-MM-dd') 
                                    //    var datee = new Date(item.TDate)
                                    //    console.log("Date here",isod.toString().substring(2, 10))
                                    return(  
                                    <tr>

                                        <td>{index+4}</td>
                                        <td>{item.transactionType} </td>
                                        <td>{isod.toString().substring(2, 10)}</td>
                                        {/* <td>{new Date()}</td> */}
                                        
                                        <td>{item.transactionAmount}</td>
                                        <td>{item.Notes}</td>
                                        <td onClick={()=>{
                                            setAmount(item?.transactionAmount)
                                            setType(item?.transactionType)
                                            seteditStatus(item?.EditStatus)
                                            setDate(item?.TDate)
                                            setNotes(item?.Notes)
                                            setRID(item?._id)
                                            console.log("clicked",item)
                                            
                                        }}><FontAwesomeIcon
                                             icon={faGear} className="FontAwesomeIcon"
                                             onClick={()=>{setEditDisplay(true)}}
                                        /></td>
                                        {/* <td>{item.transactionID}</td>
                                        <td>{item.TAccount}</td> */}
                                        
                                    </tr>
                                  )
                                })}
                                  
                                   <tr>

                                        <td><b>{"Total Deduction:"}</b></td>
                                        <td>{""} </td>
                                        <td>{""}</td>
                                        {/* <td>{new Date()}</td> */}
                                        
                                        <td>{""}</td>
                                        <td><b>{`ZMK ${dedSum}`}</b></td>
                                        {/* <td>{item.transactionID}</td>
                                        <td>{item.TAccount}</td> */}
                                        
                                    </tr>
                                
                                </tbody>
                            </table>
                            
                            

                        </div>

              
                
                
                </div>
        </>
    )

}

export default Reports;